import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PrefsProvider, usePrefs } from "@/context/PrefsContext";
import { FloatingCardsProvider } from "@/context/FloatingCards";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DispatchPage from "@/pages/DispatchPage";
import AdminPage from "@/pages/AdminPage";

function Protected({ children, admin = false }) {
  const { user } = useAuth();
  if (user === null) return <div className="grid-desktop h-screen flex items-center justify-center"><span className="overline-label">Loading…</span></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function ThemedToaster() {
  const { theme } = usePrefs();
  return <Toaster theme={theme} position="bottom-right" offset={72} richColors closeButton toastOptions={{ className: "font-sans text-[13px]" }} />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PrefsProvider>
          <FloatingCardsProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/admin/*" element={<Protected admin><AdminPage /></Protected>} />
              <Route path="/" element={<Protected><DispatchPage /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ThemedToaster />
          </FloatingCardsProvider>
        </PrefsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
